<template>
    <transition
        appear
        :css="false"
        @enter="slideIn"
    >
        <slot />
    </transition>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'SlideInTransition',
    props: {
        from: {
            type: String,
            required: true,
            default: ''
        },
        translateX: {
            type: String,
            default: '50vw'
        },
        translateY: {
            type: String,
            default: '3vw'
        },
        stagger: {
            type: Number,
            default: 0.2
        },
        tweenDuration: {
            type: Number,
            default: 1
        },
        delay: {
            type: Number,
            default: 0
        },
        ease: {
            type: String,
            default: 'power4.out'
        }
    },
    methods: {
        slideIn(el, done)
        {
            // wenn v-show verwendet wird, setzen wir visibility auf hidden, damit Element trotzdem
            // den Platz einnimmt
            const {style} = el;
            if (style.display === 'none')
            {
                done();
                style.visibility = 'hidden';
                style.display = '';
                return;
            }
            if (style.visibility === 'hidden')
            {
                style.visibility = '';
            }

            const {
                from,
                translateX,
                translateY,
                stagger,
                tweenDuration: duration,
                delay,
                ease
            } = this;
            const targets = Array.from(el.children);
            const fromVars = {opacity: 0};

            if (from === 'left' || from === 'right')
            {
                fromVars.translateX = `${from === 'left' ? '-' : ''}${translateX}`;
            }
            else if (from === 'top' || from === 'bottom')
            {
                fromVars.translateY = `${from === 'top' ? '-' : ''}${translateY}`;
            }

            gsap.timeline({
                onComplete: () =>
                {
                    done();
                    this.$emit('complete');
                }
            })
                .fromTo(
                    targets,
                    fromVars,
                    {
                        delay,
                        duration,
                        stagger,
                        translateX: 0,
                        translateY: 0,
                        opacity: 1,
                        ease
                    }
                )
                .set(targets, {clearProps: 'all'});
        }
    }
};
</script>
